import {h, Fragment} from "preact"
import { useEffect, useRef } from "preact/hooks"

export default function FlickityCarousel({ className, checkInit, options, children }) {
    const prevSlides = useRef(children?.length ?? 0);
    const carouselInstanceRef = useRef(null);
    const carouselElRef = useRef(null);

    useEffect(() => {
        const initFlickity = () => {
            if(!carouselElRef.current) return;
            carouselInstanceRef.current = new window.Flickity(carouselElRef.current, options);
        }

        const destroyFlickity = () => {
            if(!carouselInstanceRef.current) return;
            carouselInstanceRef.current.destroy();
            carouselInstanceRef.current = null;
        }

        const checkFlickity = () => {
            if(!window.Flickity || !carouselElRef.current || !children || children.length === 0) return;
            if(checkInit() && !carouselInstanceRef.current) {
                initFlickity();
            } else if (checkInit() && children.length !== prevSlides.current) {
                destroyFlickity();
                initFlickity();
            } else if (!checkInit() && carouselInstanceRef.current) {
                destroyFlickity();
            } else if(checkInit() && carouselInstanceRef.current) {
                carouselInstanceRef.current.resize();
            }
        }

        checkFlickity();
        window.addEventListener('resize', checkFlickity);
        return () => window.removeEventListener('resize', checkFlickity);
    }, [ children, options, checkInit ])

    return (
        <div className={`${className}`} ref={carouselElRef}>
            {children}
        </div>
    )
}
